import React, { Component } from 'react'
import { connect } from 'react-redux'
import ImageLoader from 'alt-imageloader'
import { withRouter } from 'react-router-dom'
import overflowBody from '../utils/overflowBody'

class ModalContainer extends Component {
    state = {
        mainImgKey: 0,
        escPressed: false,
    }

    static defaultProps = {
        data: null,
        langData: {}
    }

    componentDidMount() {
        overflowBody(true)
        window.addEventListener('keydown', this.handleKeyPress)
    }

    componentWillUnmount() {
        overflowBody(false)
        window.removeEventListener('keydown', this.handleKeyPress)
    }

    setMainImg = (key) => {
        this.setState({
            mainImgKey: key
        })
    }

    nextPicture = () => {
        if (this.props.data.galerija) {
            let newKey = this.state.mainImgKey + 1
            if (newKey > this.props.data.galerija.split(',').length) {
                newKey = 0
            }
            this.setState({
                mainImgKey: newKey
            })
        }
    }

    handleKeyPress = (e) => {
        if (e.keyCode === 27) {
            this.closeModal()
        }
    }

    closeModal = () => {
        if (this.props.history.action === 'POP') {
            this.props.history.push('/reference')
        } else {
            this.props.history.goBack()
        }
    }

    preventClick = (e) => {
        e.stopPropagation()
    }

    generateDesc = htmlString => ({
        __html: htmlString
    })

    render() {
        if (!this.props.data) {
            return null
        }
        const galleryData = this.props.data.galerija.length > 0 ?
            this.props.data.galerija.split(',') :
            []
        galleryData.unshift(this.props.data.glavna_slika)

        const paginationItems = galleryData.map((val, key) => {
            const activeClass = key === this.state.mainImgKey ? 'pagination-container__item--active' : ''

            return (
                <div
                    key={key}
                    onClick={this.setMainImg.bind(null, key)}
                    className={`pagination-container__item ${activeClass}`}
                >
                </div>
            )
        })

        return (
            <div
                className="modal-outer"
            >
                <div className="modal-inner" onClick={this.closeModal}>
                    <div className="container modal-container">
                        <div className="row modal-row" onClick={this.preventClick}>
                            <div
                                className="modal-close"
                                onClick={this.closeModal}
                            >
                                <img
                                    className="modal-close__img"
                                    src="/images/ico/bed_x.png"
                                />
                            </div>
                            <div className="col-md-12">
                                <h1 className="modal__title header1--small">{this.props.data.naziv}</h1>
                            </div>
                            <div className="col-md-8">
                                <div
                                    className="modal-text"
                                    dangerouslySetInnerHTML={this.generateDesc(this.props.data[`opis_${this.props.activeLang}`]) || '-'}
                                >
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="modal-info">
                                    <div className="modal-info-title">
                                        <span className="modal-info-title__text">{this.props.langData.purpose}</span>
                                        <span className="modal-info-title__text">{this.props.langData.service}</span>
                                        <span className="modal-info-title__text">{this.props.langData.location}</span>
                                        <span className="modal-info-title__text">{this.props.langData.year}</span>
                                        <span className="modal-info-title__text">{this.props.langData.surface}</span>
                                        <span className="modal-info-title__text">{this.props.langData.investor}</span>
                                    </div>
                                    <div className="modal-info-desc">
                                        <span className="modal-info-desc__text">{this.props.data[`namjena_${this.props.activeLang}`] || '-'}</span>
                                        <span className="modal-info-desc__text">{this.props.data[`usluga_${this.props.activeLang}`] || '-'}</span>
                                        <span className="modal-info-desc__text">{this.props.data.lokacija || '-'}</span>
                                        <span className="modal-info-desc__text">{this.props.data.godina || '-'}</span>
                                        <span className="modal-info-desc__text">{this.props.data.povrsina || '-'}</span>
                                        <span className="modal-info-desc__text">{this.props.data.investitor || '-'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="pagination-container">
                                    {paginationItems}
                                </div>
                            </div>
                            <div className="col-md-12" onClick={this.nextPicture}>
                                <div className="modal-main-img">
                                    <ImageLoader
                                        background={`/uploaded/${galleryData[this.state.mainImgKey]}`}
                                        isImage
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData.modal,
    activeLang: state.activeLang
})


export default withRouter(connect(mapStateToProps)(ModalContainer))



// WEBPACK FOOTER //
// ./src/scripts/containers/ModalContainer.jsx